/// <reference types="@types/google.maps" />
import { GOOGLE_PUBLIC_API_KEY } from '@root/config/constants';

import loadjs from 'loadjs';
import * as qs from 'qs';

const GMAP_LOADJS_ID = 'googleMapsAPI';
const CALLBACK_NAME = 'clutterMapsCB';

let promise: Promise<typeof google.maps>;

const loadMapsApi = () => {
  if (promise) return promise;
  if (!GOOGLE_PUBLIC_API_KEY) return null;

  const queryString = qs.stringify(
    {
      key: GOOGLE_PUBLIC_API_KEY,
      libraries: 'places',
      region: 'US',
      language: 'en',
      v: 'quarterly',
      callback: CALLBACK_NAME,
    },
    { addQueryPrefix: true },
  );

  loadjs(
    `https://maps.googleapis.com/maps/api/js${queryString}`,
    GMAP_LOADJS_ID,
  );

  promise = new Promise((resolve) => {
    (window as any)[CALLBACK_NAME] = () => {
      resolve(google.maps);
    };
  });

  return promise;
};

export { GMAP_LOADJS_ID, loadMapsApi };
